/**
 * @module fetchBrands 
 * 
 */
import Env from '@/env';
import NormalApis from '@/Components/Controllers/NormalApis';

export default {

    /**
     * Fetch brand list
     */
    fetchBrands(locationId = null) {
      let url = `${Env.productUrl}/api/v1/brands${locationId ? '?location_id=' + locationId : ''}`;
      return NormalApis.getApi(url, {
        "app-id": Env.productAppId,
        "app-secret": Env.productAppSecret
      })
      .then(res => res)
      .catch(err => err);
    },


    /**
     * Search bassed on params and product_name
     */
    newSearch({
      product_name,
      search_params,
      nearest_location_ids
    }) {

      let url = `${Env.productUrl}/api/v1/locationProducts/products?include_variants=1&include_thc_cbd=1&include_brands=1&include_cannabis_attributes=1`;
      let params = '';
      // Check if product name has value
      if (product_name != '') {
          params += `&product_name=${product_name}`;
      }

      for (let key in search_params) {
          if (Array.isArray(search_params[key])) {
              // Push to apionly if has value
              if (search_params[key].length > 0) {
                  if (key == 'thc') {
                      params += `&${key}=${search_params[key].join('|')}`;
                  } else {
                      params += `&${key}=${search_params[key].join()}`;
                  }
              }
          } else {
              params += search_params[key] ? `&${key}=${search_params[key]}` : '';
          }
      }
      url += params;
      return AuthApi.postApi(url, {
        "app-id": Env.productAppId,
        "app-secret": Env.productAppSecret
      },{
        location_ids:nearest_location_ids
      })
      .then(res => res)
      .catch(err => err);
  },

}